import React from 'react'
import { EventGQL } from '../../../Api'
import { WeekItemStyle } from './styles'

type WeekItemProps = {
  active: boolean
  event: EventGQL
  handleEventChange: (event: EventGQL) => void
}

export const MatchupItem: React.FC<React.PropsWithChildren<WeekItemProps>> = ({
  event,
  active = false,
  handleEventChange,
}) => {
  return (
    <>
      {event.seasonSegment === 'allstar' ? (
        <WeekItemStyle active={active}>
          <div className="week-item-text">All Star Weekend</div>
        </WeekItemStyle>
      ) : (
        <WeekItemStyle active={active} onClick={() => handleEventChange(event)}>
          <div className="week-item-text">
            {event.awayTeam?.fullName || 'TBA'} v. {event.homeTeam?.fullName || 'TBA'}
          </div>
        </WeekItemStyle>
      )}
    </>
  )
}
